import React, { Component } from 'react'
import { Icon, Spin, Table, Tag, Divider, Modal } from 'antd';
import MenuSider from '../../../../components/MenuSider'
import ScrollToTop from '../../../../components/ScrollToTop'
import { Odata_Url, Constants, Odata_2_Url } from '../../../../Constants/Constants'
import CreateOrUpdate from './CreateOrUpdate'
import './JobType.css'
import axios from 'axios'

const { Column } = Table
const Confirm = Modal.confirm

export default class JobTypeMaster extends Component {
    constructor(props) {
        super(props);
        this.handleClick = this.handleClick.bind(this);
        this.generateJob = this.generateJob.bind(this);

        this.state = {
            jobtype: [],
            popupVisible: false,
            onLoading: false
        }
    }

    componentDidMount() {
        this.generateJob();
    }

    generateJob() {
        this.setState({ onLoading: true });
        this.getJobType().then(jobtype => {
            this.setState({
                jobtype: jobtype,
            })
            window.localStorage.setItem('PassJobtype', JSON.stringify(jobtype));
            this.setState({ onLoading: false });
        })
    }

    async getJobType() {
        var Token
        let res = await axios.get(Constants.BASE_URL + 'auth/token')
            .then(async (response) => {
                Token = response.data
                let cat_res = await axios.get(
                    Odata_Url + 'OJobType?$filter=IsDeleted eq false',
                    {
                        headers: {
                            "Authorization": "Bearer " + Token,
                        }
                    }
                )
                    .then((response) => {
                        const data = [];
                        response.data.value.forEach(function (element) {
                            data.push(element);
                        });
                        return data;
                    },
                        (error) => {
                            console.log(error);
                        });
                return cat_res;
            },
                (error) => {
                    console.log(error);
                    if (401 === error.response.status) {
                        window.location.href = "auth";
                    }
                });
        return res;
    }

    handleClickDelete(id) {
        Confirm({
            title: 'Do you want to delete the item?',
            content: 'When clicked the OK button the item will be deleted.',
            onOk: () => {

                var job_list = JSON.parse(window.localStorage.getItem('PassJobtype'))
                var jobtype_data = {};
                job_list.map((l, i) => {
                    if (l.PKJobTypeID === (id + 1)) {
                        jobtype_data = l;
                    }
                })

                var JobType = JSON.stringify(jobtype_data)

                this.getToken().then(token => {

                    let tokenHeader = {
                        headers: {
                            "Authorization": "Bearer " + token,
                        }
                    };

                    axios.post(Constants.BASE_URL + "api/Master/DeleteJobType", { JobType: JobType }, tokenHeader)
                        .then((response) => {
                            this.getJobType().then(jobtype => {
                                this.setState({
                                    jobtype: jobtype,
                                })
                                window.localStorage.setItem('PassJobtype', JSON.stringify(jobtype));
                                this.setState({ onLoading: false });
                            })
                        },
                            (error) => {
                                console.log(error);
                                this.setState({ onLoading: false });
                            })
                });

                
            },
            onCancel() { }
        })
    }

    handleClick(id) {
        this.setState(prevState => ({
            popupVisible: !prevState.popupVisible,
            jobtype_id: id
        }));
    }

    getToken() {
        var $getToken = new Promise((resolve, reject) => {
            axios.get(Constants.BASE_URL + 'auth/token').then((res) => {
                resolve(res.data);
            }).catch(err => {
                if (401 === err.response.status) {
                    window.location.href = "auth";
                }
                reject(err);
            });
        });
        return $getToken;
    }

    render() {
        const uploadButton = (
            <div>
                <Icon type="plus" />
                <div className="ant-upload-text">Upload</div>
            </div>
        );
        return (
            <div style={{ width: "100%" }}>
                <Spin spinning={this.state.onLoading} size="large" className='spin' tip="Loading...">

                    <ScrollToTop />
                    <MenuSider title="Master Job Type">
                        <div style={{ width: "100%", marginTop: "10px" }}>
                            <Table dataSource={this.state.jobtype}>
                                <Column
                                    title=''
                                    dataIndex='Image_name'
                                    width={100}
                                    render={(data) => (
                                        <img src={"/images/" + data} style={{ borderRadius: "30%", filter: "grayscale(100%)", objectFit: "contain", height: '25px' }} />
                                    )}
                                />
                                <Column
                                    title='Name (Thai)'
                                    dataIndex='JobType1'
                                />
                                <Column
                                    title='Name (Eng)'
                                    dataIndex='JobType_EN'
                                />
                                <Column
                                    title='Type'
                                    dataIndex='Type'
                                    align='center'
                                    render={type => (
                                        <span>
                                            {
                                                <Tag color={type == 'office' ? 'pink' : type == undefined ? 'red' : 'blue'} key={type}>
                                                    {type ? type.toUpperCase() : 'NOT SET'}
                                                </Tag>
                                            }
                                        </span>
                                    )}
                                />
                                <Column
                                    title='Status'
                                    dataIndex='IsActived'
                                    align='center'
                                    render={(active) => (
                                        <span>
                                            <Tag color={active ? 'green' : 'volcano'} key={active}>
                                                {active ? 'Active' : 'Inactive'}
                                            </Tag>
                                        </span>
                                    )}
                                />
                                <Column
                                    title='Action'
                                    width={100}
                                    align='center'
                                    render={(data, row) => (
                                        <div>
                                            <a href="javascript:;" onClick={() => this.handleClick(row.PKJobTypeID - 1)}>
                                                <Icon type={"edit"} style={{ fontSize: "17px" }} />
                                            </a>
                                            <Divider type="vertical" />
                                            <a href="javascript:;" onClick={() => this.handleClickDelete(row.PKJobTypeID - 1)}>
                                                <Icon type={"delete"} style={{ fontSize: "17px" }} />
                                            </a>
                                        </div>
                                    )}
                                />

                            </Table>
                            {
                                this.state.popupVisible && (
                                    <div id="popup-category" className="popup-category" ref={node => { this.node = node; }}>
                                        <div className="popup-job-content job-animate">
                                            <div className="popup-job-topic" >
                                                <CreateOrUpdate onclose={this.handleClick} generateJob={this.generateJob} jobtype_id={this.state.jobtype_id} />
                                            </div>
                                        </div>
                                    </div>
                                )
                            }
                        </div>
                        <div onClick={() => this.handleClick(9999999999)} style={{ width: "70px", height: "70px", position: "fixed", right: "25px", bottom: "40px", border: "1px solid rgb(1 135 124)", backgroundColor: "rgb(0,152,139)", borderRadius: "50%", cursor: "pointer" }}>
                            <Icon type="plus" style={{ left: "25%", top: "25%", position: "relative", color: "white", fontSize: "35px" }} />
                        </div>
                    </MenuSider>
                </Spin>
            </div>
        )
    }
}